import { render } from "./CreatorIncomeView.vue?vue&type=template&id=6012627e&scoped=true"
import script from "./CreatorIncomeView.vue?vue&type=script&lang=js"
export * from "./CreatorIncomeView.vue?vue&type=script&lang=js"

import "./CreatorIncomeView.vue?vue&type=style&index=0&id=6012627e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6012627e"]])

export default __exports__